import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import React, { useEffect, useState } from "react";
import { HashRouter as Router } from "react-router-dom";
import "./dx-styles.scss";
import LoadPanel from "devextreme-react/load-panel";
import { NavigationProvider } from "./contexts/navigation";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";
import UnauthorizedContent from "./UnauthorizedContent.tsx";
import { MsalProvider, useMsal, useIsAuthenticated } from "@azure/msal-react";
import msalInstance from "./auth/msalInstance";
import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";
import { useUser } from "./contexts/userContext";
import adminApi from "./api/admin";
import { UserProvider } from "./contexts/userContext";
import { useDispatch } from "react-redux";
import { setUserAuth } from "./slices/authSlice";

function App() {
	const { accounts } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const { userData, setUserData, isLoading, setIsLoading } = useUser();
	const dispatch = useDispatch();
	const [canAccessUi, setCanAccessUi] = useState(false);

	config({ licenseKey });

	useEffect(() => {
		const fetchUserData = async () => {
			if (isAuthenticated && accounts[0]) {
				try {
					// console.log("ACCOUNTS RESULT");
					// console.log(accounts[0]);
					const username = accounts[0].username;
					const tokenResult = await adminApi.users.getToken(username);
					// console.log("TOKEN RESULT");
					// console.log(tokenResult);
					dispatch(setUserAuth(tokenResult.result));
					setUserData(tokenResult.result.user);
					setCanAccessUi(tokenResult.result.user.canAccessUi);
				} catch (error) {
					console.error("Failed to fetch user data:", error);
				} finally {
					setIsLoading(false);
				}
			}
		};

		if (isAuthenticated && !userData) {
			fetchUserData();
		}
	}, [isAuthenticated, accounts, userData, setUserData, setIsLoading]);

	// Redirect to login
	if (!accounts || accounts.length === 0) {
		return <UnauthenticatedContent />;
	}

	// Not authorized
	if (canAccessUi === false) {
		return <UnauthorizedContent />;
	}

	if (isLoading) {
		return <LoadPanel visible={true} />;
	}

	return isAuthenticated ? (
		<Content user={{ ...accounts[0], ...userData }} />
	) : (
		<LoadPanel visible={true} />
	);
}

export default function Root() {
	const screenSizeClass = useScreenSizeClass();

	return (
		<Router>
			<MsalProvider instance={msalInstance}>
				<UserProvider>
					<NavigationProvider>
						<div className={`app ${screenSizeClass}`}>
							<App />
						</div>
					</NavigationProvider>
				</UserProvider>
			</MsalProvider>
		</Router>
	);
}
